import { render } from "./RejectWithDamageConfirmation.vue?vue&type=template&id=3ea236a8&ts=true"
import script from "./RejectWithDamageConfirmation.vue?vue&type=script&lang=ts"
export * from "./RejectWithDamageConfirmation.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__